import { Controller, useFormContext } from 'react-hook-form';

import { FormTextField } from '@/components/Form/FormTextField/FormTextField';
import type { CommonFieldDef } from '@/core/dcr/fields/types';

import { useFieldLabel } from '../../_hooks/useFieldLabel';
import { hasValue } from '../../_utils/hasValue';

type Props = {
	name: string;
	def: CommonFieldDef;
};

export const TextInput = ({ name, def }: Props) => {
	const { control } = useFormContext();
	const fieldLabel = useFieldLabel();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field, fieldState }) => (
				<FormTextField
					id={name}
					name={field.name}
					label={fieldLabel(def)}
					isRequired={def.required}
					isDirty={hasValue(field.value)}
					indicateError={!!fieldState.error}
					errorMessage={fieldState.error?.message}
					defaultValue={(field.value as string | undefined) ?? ''}
					onChange={field.onChange}
					isDateField={def.kind === 'date'}
					maxLength={def.maxLength}
				/>
			)}
		/>
	);
};
